import React, {useState} from 'react';
import PropTypes from "prop-types";
import {duckify} from "../../utils/duckify";
import {deletedContacts as deletedContactsDuck, flashMessages, modals} from '../../ducks';
import FlashRoot from 'components/FlashMessage/FlashRoot';
import {formatDateTime} from '../../../react/utils/i18n';

const DeletedContactPage = ({deletedContacts, dispatch}) => {

   const [loading, setLoading] = useState(false)

  const restoreContact = (contactId) => {
    setLoading(true)
    dispatch(deletedContactsDuck.actions.update({ id: contactId }))
      .then((response) => dispatch(flashMessages.actions.show({
        dismissible: true,
        message: <React.Fragment>Contact successfully restored. Application and inquiry forms may need to be re-imported. <a
          href={"/contacts/" + response.result['contact_id']}>Click here to see record.</a></React.Fragment>
      })))
      .then(() => dispatch(deletedContactsDuck.actions.markDirty()))
      .catch((error) => {
        let message = "This contact could not be successfully restored."

        // Check if the error response contains a specific message
        if (error && error.response && error.error) {
          message = error.error;
        }

        dispatch(flashMessages.actions.show({
          message: message,
          type: 'danger'
        }))
      })
      .finally(() => setLoading(false))
  }
  const confirmRestore = (contactId) => {
    dispatch(modals.actions.show('VerificationModal', {
      title: 'Confirm Contact Restore',
      message: 'Restoring this contact will recover the contact record and most of its associated forms, files and checklist answers. Some data may need to be manually re-created. Do you wish to continue?',
      onConfirm: () => {dispatch(modals.actions.hide());
        restoreContact(contactId)}
    }))
  }

  return (<div><h2>Partial Contact Restore</h2>
    <p>The contact record will be restored to the final year, grade and school year, along with any forms and uploaded files tied to checklist items. Answers to fields will also be restored.
      Applications and inquiries will need to be re-imported.</p>
    <FlashRoot/>
    <table className={'table'} style={{width: '50%'}}>
      <thead>
      <th>First Name</th>
      <th>Last Name</th>
      <th>Deleted By</th>
      <th>Deleted On</th>
      <th></th>
      </thead>
      <tbody>{deletedContacts.map((deletedContact) =>  <tr key={deletedContact.id}>
        <td>{deletedContact.first_name}</td>
        <td>{deletedContact.last_name}</td>
        <td>{deletedContact.deleted_by}</td>
        <td>{formatDateTime(deletedContact.created_at)}</td>
        <td><button className={'btn btn-success'} disabled={loading} onClick={() => confirmRestore(deletedContact.id)}>Restore</button></td>
      </tr>)}</tbody>
    </table>
  </div>)
}

const mapDucksToProps = () => ({
  deletedContacts: deletedContactsDuck
})

DeletedContactPage.propTypes = {
  deletedContacts: PropTypes.array
}

DeletedContactPage.defaultProps = {
  deletedContacts: []

};

export default duckify(mapDucksToProps)(DeletedContactPage);
